import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
import { postSubmitForm } from "../../helpers/forms_helper";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import showNotification from "../../helpers/show_notification";

const animatedComponents = makeAnimated();

const AddInventory = (props) => {
  const store_id = localStorage.getItem("store_id")

  useEffect(() => {
    loadAllItems();
    if (props.selectedItem) {
      setSelectedItem(props.selectedItem);
    }
  }, []);
  const refContainer = useRef(null);
  const refSelectItem = useRef(null);
  const [isDisabled, setIsDisabled] = useState();
  
  const handleValidSubmit = async (e, v) => {
    try {
      setIsDisabled(true)
      let data_to_send = {};
      data_to_send.store_id = store_id;
      data_to_send.equipment_id = selectedItem._id;
      data_to_send.unit = v.unit; 
      data_to_send.quantity = Number(v.quantity); 
      data_to_send.remarks = v.remarks;
      data_to_send.cost_price = Number(v.cost_price);

      let url = process.env.REACT_APP_BASEURL + "storeequipmentinventories/insert";

      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        showNotification(response.message, "Success");
        refSelectItem.current.select.clearValue();
        refContainer.current.reset();
        if (props.isRefreshData) {
          props.refreshData();
          props.handleClosePopup();
        }
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error, "Error");
    } finally {
      setIsDisabled(false)
    }
  };

  const [allItems, setAllItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const loadAllItems = async () => {
    let url = process.env.REACT_APP_BASEURL + "equipments/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllItems(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };


  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <AvForm
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v);
                }}
                ref={refContainer}
              >
                <CardTitle>{props.t("Update Inventory")}</CardTitle>
                <CardSubtitle className="mb-3">
                  {props.t(
                    "Enter the following details to add items to inventory"
                  )}
                </CardSubtitle>
                <Row>
                  <Col lg={6}>
                    <Label>{props.t("Equipment")}</Label>
                    <Select
                      ref={refSelectItem}
                      value={selectedItem}
                      onChange={(selected) => {
                        setSelectedItem(selected)
                      }}
                      options={allItems}
                      classNamePrefix="select2-selection"
                      components={animatedComponents}
                      required
                    />
                  </Col>
               
                    <Col lg={6}>
                    <Label>{props.t("Quantity")}</Label> <br />
                    <AvField
                      name="quantity"
                      placeholder={props.t("Enter Quantity ")}
                      type="number"
                      errorMessage={props.t("Only numbers are allowed.")}
                      validate={{
                       required:{value:true},
                      }}
                    />
                  </Col>
                 
                  <Col lg={6}>
                    <Label>
                      {props.t("Cost Price")}
                      {selectedItem && " (per " + selectedItem.unit + ")"}
                    </Label>
                    <AvField
                      name="cost_price"
                      placeholder={props.t("Enter Cost Price")}
                      type="text"
                      value={selectedItem && selectedItem.cost_price}
                      validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                      }}
                    />
                  </Col>
                 
                 
                  <Col lg={6}>
                    <AvField
                      name="remarks"
                      label={props.t("Remarks")}
                      placeholder={props.t("Enter Remarks")}
                      type="textarea"
                    />
                  </Col>
                  <Col lg={12}>
                    <hr />
                    <FormGroup className="mb-0 text-center">
                      <div>
                        <Button type="submit" color="primary" className="mr-1" style={{width:"100px"}} disabled={isDisabled}>
                          {isDisabled? <Spinner size={"sm"}/> :props.t("Submit")}
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>

    
        </Col>
      </Row>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AddInventory))
);
